import React from 'react'
import { Box, CircularProgress, Alert, Typography } from '@mui/material'
import {
  BarChart,
  Bar,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

const shortMonthNames = {
  '01': 'Sty', '02': 'Lut', '03': 'Mar', '04': 'Kwi',
  '05': 'Maj', '06': 'Cze', '07': 'Lip', '08': 'Sie',
  '09': 'Wrz', '10': 'Paź', '11': 'Lis', '12': 'Gru',
}

const OrangeOpaskaTrend = ({ data, loading, error }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) return <Alert severity="error">{error}</Alert>
  if (!data) return null

  const monthData = (data.month_by_month || []).map(d => {
    const parts = d.month.split('-')
    const label = `${shortMonthNames[parts[1]] || parts[1]} ${parts[0]}`
    return { ...d, label }
  }).reverse()

  // Timeseries with service split (Panel 21)
  const tsData = (data.timeseries_service || []).map(d => ({
    ...d,
    label: d.date.slice(5),
  }))
  const step = Math.max(1, Math.floor(tsData.length / 90))
  const sampledTs = tsData.filter((_, i) => i % step === 0 || i === tsData.length - 1)

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>Sprzedaż miesiąc po miesiącu</Typography>
      {monthData.length === 0 ? (
        <Alert severity="info">Brak danych trendu</Alert>
      ) : (
        <Box sx={{ height: 350, mb: 4 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={monthData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" fontSize={11} />
              <YAxis />
              <Tooltip formatter={(value) => [value, 'Sprzedaż']} />
              <Bar dataKey="sales" fill="#ef6c00" name="Sprzedaż" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      )}

      {sampledTs.length > 0 && (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>Sprzedaż urządzeń z usługą i bez</Typography>
          <Box sx={{ height: 350 }}>
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={sampledTs} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="label" fontSize={10} interval="preserveStartEnd" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Area type="monotone" dataKey="z_usluga" name="Sprzedaż z usługą" stackId="1" stroke="#4caf50" fill="#a5d6a7" />
                <Area type="monotone" dataKey="bez_uslugi" name="Sprzedaż bez usługi" stackId="1" stroke="#ff9800" fill="#ffcc80" />
              </AreaChart>
            </ResponsiveContainer>
          </Box>
        </>
      )}
    </Box>
  )
}

export default OrangeOpaskaTrend
